import { render, staticRenderFns } from "./MergersList.vue?vue&type=template&id=7568d2b2&scoped=true"
import script from "./MergersList.vue?vue&type=script&lang=js"
export * from "./MergersList.vue?vue&type=script&lang=js"
import style0 from "./MergersList.vue?vue&type=style&index=0&id=7568d2b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7568d2b2",
  null
  
)

export default component.exports